import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Stack,
  Radio,
  DialogActions,
  Slide,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import { Input as BaseInput } from "@mui/base/Input";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { toaststyle } from "../../Utils/toaststyle";

const Input = React.forwardRef(function CustomInput(
  propsDashboard,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return <BaseInput slots={{ input: InputElement }} {...propsDashboard} ref={ref} />;
});



const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};
const InputElement = styled("input")(
  ({ theme }) => `
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === "dark" ? "rgba(0,0,0, 0.5)" : "rgba(0,0,0, 0.05)"
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? blue[600] : blue[200]
    };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);
const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? blue[600] : blue[200]
    };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);

const WhatsAppInitDialogBox = ({
  whatsappOpenDialog,
  whatsappDialogClose,
  selectedUser,
}) => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [serviceType, setserviceType] = useState("");
  const [serviceTypeValidation, setserviceTypeValidation] = useState(true);
  const [serviceMessage, setserviceMessage] = useState("");
  const [url, seturl] = useState("https://");

  const serviceText = `Dear Mr. ${selectedUser.username},

    We have completed a Vehicle Health Check on your vehicle whilst it was in our care today.
    
    Here’s a quick guide to Vehicle Health Check condition findings which are split into categories of Red, Amber or Green:
    
    Red – This indicates that the item requires urgent attention
    
    Amber – This indicates that the item will require attention, but is not yet critical
    
    Green – This indicates that the item is OK and no further work is necessary
    
    You can view your vehicle check report on-line by clicking this link:
    
    "
    ${url}
    "
    
    Please call us on if you have any further instructions or queries whilst we have your vehicle. There is a call button contained within the web page link if required.
    
    Kind Regards,
    
    The Service Team`;

  const salesText = `Hello ${selectedUser.username}, I am your BMW sales representative. Type "Hi" to continue the conversation.`;

  useEffect(() => {
    if (serviceMessage) {
      setserviceMessage(serviceText);
      if (url.length > 8) {
        setserviceTypeValidation(false);
      } else {
        setserviceTypeValidation(true);
      }
    }
  }, [url]);

  const ClickToWhatsapp = () => {
    if (!serviceType) return;
    axios
      .post(
        BaseUrl + "/users/initatewhatsapp",
        {
          phonenumber: selectedUser.phonenumber,
          customername: selectedUser.username,
          agent_email: loggedInAgent.email,
          type: "whatsapp",
          agent_Type: serviceType,
          url: serviceType == "Service" ? url : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          whatsappDialogClose();
          toast.success(res.data.message, toaststyle);
        } else {
          whatsappDialogClose();
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((err) => { });
  };
  return (
    <Dialog
      open={whatsappOpenDialog}
      keepMounted
      onClose={whatsappDialogClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth maxWidth="md"
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "16px", fontWeight: 600, color: "#0b3363", boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
      >
        Initiate Whatsapp
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack spacing={2} className="mt-3">
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group" className="fs-13">
                Service Type
              </FormLabel>
              <RadioGroup
                size="small"
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={serviceType}
                sx={{ fontSize: "13px" }}
                onChange={(e) => {
                  setserviceType(e.target.value);
                  if (e.target.value == "Service") {
                    setserviceMessage(serviceText);
                    setserviceTypeValidation(true);
                  } else {
                    setserviceMessage(salesText);
                    setserviceTypeValidation(false);
                  }
                }}
              >
                <FormControlLabel
                  value="Sales"
                  control={<Radio />}
                  label="Sales"
                  size="small"
                />
                <FormControlLabel
                  value="Service"
                  control={<Radio />}
                  label="Service"
                  size="small"
                />
              </RadioGroup>
            </FormControl>
            {serviceType == "Service" && (
              <Input
                value={url}
                aria-label="Demo input"
                type="url"
                placeholder="URL..."
                onChange={(e) => {
                  seturl(e.target.value);
                }}
              />
            )}
            <label className="form-label">Message</label>
            <Textarea
              className="CONTACT-LIST-AREA w-100"
              disabled
              value={serviceMessage}
              aria-label="minimum height"
              minRows={4}
              maxRows={6}
              placeholder="Message...."
              sx={{ overflow: "scroll" }}
            />
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          onClick={ClickToWhatsapp}
          disabled={serviceTypeValidation}
        >
          CONFIRM
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsAppInitDialogBox;
